<template>
  <div class="player">
    <AdminNavBar/>

    <main role="main" class="ml-sm-auto px-4">
      <template>
        <b-breadcrumb>
          <b-breadcrumb-item to="/players"
            ><b-icon-collection-play-fill></b-icon-collection-play-fill>
            Players</b-breadcrumb-item
          >
          <b-breadcrumb-item v-if="player" active>{{
            player.username
          }}</b-breadcrumb-item>
        </b-breadcrumb>
      </template>

      <b-link @click="load" size="sm" class="float-left"
        ><small>Refresh</small></b-link
      >
      <div class="ml-2 mb-0 float-right text-muted">
        <small>count {{ items.length }}</small>
      </div>

      <b-table :items="items" :fields="fields" hover responsive="sm" small>
        <template v-slot:cell(play_mode)="row">
          <b-badge v-if="row.item.play_mode" pill variant="danger"
            >Test</b-badge
          >
          <b-badge v-else pill variant="secondary">Train</b-badge>
        </template>

        <template v-slot:cell(open)="row">
          <b-button @click="open(row.item.log_id)" size="sm" class="mb-2" v-b-modal="'play-open-' + row.index">
            Open
          </b-button>
        </template>
      </b-table>

      <hr>
      <div v-if="isAdmin" >
        <!-- <b-button class="btn-sm float-right" href="#" @click="download()">
          <b-icon-arrow-left-short></b-icon-arrow-left-short> Download
        </b-button> -->
        <b-button variant="danger" class="m-1" @click="repair()"
          ><b-icon-wrench></b-icon-wrench> Repair</b-button
        >
      </div>
    </main>
  </div>
</template>

<script>
import Vue from "vue";

import axios from "axios";
import dayjs from "dayjs";

import AdminNavBar from '../components/AdminNavBar';

// import { saveAs } from 'file-saver';

import { IconsPlugin } from "bootstrap-vue";
Vue.use(IconsPlugin);

//import _ from "lodash";
const { repairPlayer } = require('../maintenance');

const {isFinalized} = require ('../play-utils');

export default {
  name: "player",
  components: {
    AdminNavBar,
  },
  computed: {
    isAdmin() {
      return this.$store.state.user.role === "admin";
    },
  },
  data: function () {
    return {
      player: null,
      fields: [],
      items: [],
    };
  },
  filters: {
    toDateTime: function (date) {
      return dayjs(date).format("MM-DD-YYYY hh:mm A");
    },
    toMinSec: function (secs) {
      return dayjs.utc(secs * 1000).format("mm:ss");
    },
  },  
  methods: {
    repair() {
      repairPlayer(this.$createElement, this.player._id)
        .then(messageVNode => {
          this.load();
          this.$bvModal.msgBoxOk([messageVNode]);
        });
    },
    formatScore(score) {
      return (typeof score === 'number') ? score == 0 ? 0 : score == 1 ? 1 : score.toFixed(2) : 'Need repair';
    },
    open(log_id) {
      this.$router.push({ name: 'playerLog', params: { id: this.player._id, log_id: log_id } })
    },
    load() {
      axios
        .post(
          process.env.VUE_APP_API_URL + '/players/getInfos',
          { _id: this.$route.params.id },
          { headers: { authorization: localStorage.getItem('vle.user.token') } }
        )
        .then(result => {
          this.player = result.data;
          this.items = [];

          this.player.logs = this.player.logs.sort((a, b) => {
            return b.start_timestamp - a.start_timestamp;
          });
          
          this.player.logs.forEach((d) => {
            let time_played;
            if (d.time_played === -1 || d.time_played === undefined || d.time_played === 0) {
              if (d.end_timestamp !== null && d.end_timestamp !== undefined) {
                time_played = d.end_timestamp - d.start_timestamp;
              } else {
                time_played = null;
              }
            } else {
              time_played = d.time_played * 1000;
            }

            this.items.push({
              log_id: d.log_id,
              status: isFinalized(d) ? d.pass ? 'Pass' : 'Fail' : 'Paused',
              case_played: d.caseInfo ? d.caseInfo.codename + ' ' + d.caseInfo.name : 'NA',
              game_played: d.gameInfo ? d.gameInfo.name : 'NA',
              play_mode: !d.replay && !d.debrief,
              start_time: d.start_timestamp
                ? dayjs(d.start_timestamp).format('MM-DD-YY hh:mm:ss A')
                : 'NA',
              time_played: time_played === null ? 'NA' : dayjs.duration(time_played).format('HH:mm:ss'),
              score: this.formatScore(d.score)
            });
            if (!isFinalized(d)) console.log(d);
          });
        });
    },
    // download() {
    //   var blob = new Blob(["Hello, world!"], {type: "text/plain;charset=utf-8"});
    //   saveAs(blob, "hello world.txt");
    // }
  },
  mounted() {
    this.fields = [
      { key: 'game_played', sortable: true },
      { key: 'play_mode', sortable: true },
      { key: 'case_played', sortable: true },
      { key: 'start_time', sortable: true },
      { key: 'time_played', sortable: true },
      { key: 'status', sortable: true },
      { key: 'score', sortable: true },
      { key: 'open', sortable: false },
    ];

    this.load();
  },
};
</script>

